import { useState } from "react";
import {
  CATEGORIES, BADGES_IN_CATEGORY, BADGE_ATTR, badgeReqFor, badgeTierByReq, TIERS, tokenCostForTier, BADGE_DESC,
} from "../lib/builderData";
import { ATTRIBUTES } from "../lib/builderData";
import { BadgeMedal } from "./BadgeMedal";

const ATTR = Object.fromEntries(ATTRIBUTES.map((a) => [a.key, a]));
const TIER_ROWS = [["bronze", "Bronze"], ["silver", "Silver"], ["gold", "Gold"], ["hof", "HOF"]];
const tierColor = (label) => TIERS.find((t) => t.label === label)?.color || "#64748B";

export default function BadgesExplorer({ caps }) {
  const [open, setOpen] = useState(null);
  return (
    <div className="rounded-2xl border border-[#1E293F] bg-[#0F1424] p-5" data-testid="possible-badges">
      <div className="mb-1 text-sm font-black uppercase tracking-wider text-white">Possible Badges</div>
      <p className="mb-4 text-[11px] text-[#64748B]">Every badge and the exact attribute you need for each tier. Tap a badge to see its thresholds. Estimated tiers are marked until we record the real numbers.</p>
      <div className="space-y-4">
        {Object.entries(CATEGORIES).map(([catKey, cat]) => (
          <div key={catKey} data-testid={`pb-cat-${catKey}`}>
            <div className="mb-2 flex items-center gap-2"><span className="h-2.5 w-2.5 rounded-full" style={{ backgroundColor: cat.color }} /><span className="font-heading text-xs font-bold uppercase tracking-wider" style={{ color: cat.color }}>{cat.label}</span></div>
            <div className="flex flex-wrap gap-1.5">
              {(BADGES_IN_CATEGORY[catKey] || []).map(({ badge, attr }) => {
                const cap = caps[attr] ?? 0;
                const tier = badgeTierByReq(badge, cap);
                const locked = !tier;
                const isOpen = open === badge;
                return (
                  <div key={badge} className="w-full">
                    <button data-testid={`pb-badge-${badge.replace(/\s+/g, "-").toLowerCase()}`} onClick={() => setOpen(isOpen ? null : badge)}
                      className="flex w-full items-center justify-between gap-2 rounded-lg border px-2.5 py-1.5 text-left transition-all"
                      style={{ borderColor: locked ? "#1E293F" : `${tier.color}55`, backgroundColor: locked ? "#0B1120" : `${tier.color}14`, opacity: locked ? 0.5 : 1 }}>
                      <span className="flex items-center gap-2">
                        <BadgeMedal cat={catKey} tier={tier} size={18} dim={locked} />
                        <span className="text-[12px] font-bold" style={{ color: locked ? "#64748B" : tier.color }}>{badge}</span>
                      </span>
                      <span className="flex items-center gap-2 text-[10px] font-bold uppercase">
                        {tier ? <span style={{ color: tier.color }}>{tier.label} · {tokenCostForTier(tier.label)}pt</span> : <span className="text-[#475569]">Locked</span>}
                      </span>
                    </button>
                    {isOpen && (
                      <div className="mt-1 rounded-lg border border-[#1E293F] bg-[#0B1120] px-3 py-2" data-testid={`pb-detail-${badge.replace(/\s+/g, "-").toLowerCase()}`}>
                        {BADGE_DESC[badge] && <div className="mb-2 text-[11px] leading-relaxed text-[#94A3B8]">{BADGE_DESC[badge]}</div>}
                        <div className="mb-1 text-[10px] font-bold uppercase tracking-wider text-[#64748B]">
                          {ATTR[attr]?.label} requirements {badgeReqFor(badge).est && <span className="text-[#F59E0B]">· estimated</span>}
                        </div>
                        {TIER_ROWS.map(([k, label]) => {
                          const req = badgeReqFor(badge)[k];
                          const met = cap >= req;
                          return (
                            <div key={k} className="flex items-center justify-between py-0.5 text-[11px]">
                              <span className="flex items-center gap-1.5"><span className="w-12 font-bold uppercase" style={{ color: tierColor(label) }}>{label}</span><span className={met ? "text-[#4ADE80]" : "text-[#64748B]"}>{ATTR[attr]?.label} {req}</span></span>
                              <span className={met ? "text-[#4ADE80]" : "text-[#475569]"}>{met ? "✓" : `+${req - cap}`}</span>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
